/**
 *
 * @module sessionClientConfiguration
 *
 */

import ServiceClientConfiguration from './../configuration/serviceClientConfiguration';

/**
 *
 * @class SessionClientConfiguration
 * @extends {ServiceClientConfiguration}
 * @desc Provides configuration information used by the SessionClient.
 *
 */
export default class SessionClientConfiguration extends ServiceClientConfiguration {}



// WEBPACK FOOTER //
// ./src/services/session/sessionClientConfiguration.js